import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Tooltip from '@mui/material/Tooltip';

/** Color del cuadrado según la puntuación del día (escala naranja → verde, sobre 15 puntos posibles). */
export function getDayColor(score) {
  if (score === null || score === undefined) return { bg: '#ffffff', border: '#e0e0e0', text: '' };
  if (score === 0) return { bg: '#bdbdbd', border: '#9e9e9e', text: '0' };
  let bg, border, perfect = false;
  if (score <= 3) { bg = '#FF8C00'; border = '#e07b00'; }
  else if (score <= 6) { bg = '#FFC107'; border = '#e0a800'; }
  else if (score <= 9) { bg = '#FFD740'; border = '#e0bc00'; }
  else if (score <= 12) { bg = '#8BC34A'; border = '#6a9a2e'; }
  else if (score < 15) { bg = '#4CAF50'; border = '#388e3c'; }
  else { bg = '#4CAF50'; border = '#FFD700'; perfect = true; }
  return { bg, border, perfect, text: String(score) };
}

export function DayBadge({ score, date, onClick }) {
  const { bg, border, perfect, text } = getDayColor(score);
  const label = date
    ? new Date(date + 'T00:00:00').toLocaleDateString(undefined, { month: 'short', day: 'numeric' })
    : '';

  return (
    <Tooltip title={label} arrow placement="top">
      <Box
        onClick={onClick}
        sx={{
          width: 24,
          height: 24,
          borderRadius: 1,
          bgcolor: bg,
          border: `${perfect ? 2.5 : 1.5}px solid ${border}`,
          boxShadow: perfect ? `0 0 4px ${border}` : 'none',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontSize: '0.6rem',
          fontWeight: 700,
          color: score > 0 ? '#fff' : score === 0 ? '#555' : 'transparent',
          flexShrink: 0,
          cursor: onClick ? 'pointer' : 'default',
          transition: 'transform 0.1s, opacity 0.1s',
          '&:hover': onClick ? { opacity: 0.75, transform: 'scale(1.15)' } : {},
        }}
      >
        {text}
      </Box>
    </Tooltip>
  );
}

export function LegendSwatch({ score, label }) {
  const { bg, border, perfect } = getDayColor(score);
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
      <Box
        sx={{
          width: 14,
          height: 14,
          borderRadius: 0.5,
          bgcolor: bg,
          border: `${perfect ? 2.5 : 1.5}px solid ${border}`,
          boxShadow: perfect ? `0 0 4px ${border}` : 'none',
          flexShrink: 0,
        }}
      />
      <Typography variant="caption" color="text.secondary">
        {label}
      </Typography>
    </Box>
  );
}

export function Last5DaysLegend({ t }) {
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 2, flexWrap: 'wrap' }}>
      <Typography variant="caption" color="text.secondary">
        {t('leaderboard.legend')}:
      </Typography>
      <LegendSwatch score={null} label={t('leaderboard.legendNoPlay')} />
      <LegendSwatch score={0} label={t('leaderboard.legendNoPoints')} />
      <LegendSwatch score={2} label="1-3" />
      <LegendSwatch score={5} label="4-6" />
      <LegendSwatch score={8} label="7-9" />
      <LegendSwatch score={11} label="10-12" />
      <LegendSwatch score={14} label="13-15" />
      <LegendSwatch score={15} label="¡Perfecto!" />
    </Box>
  );
}
